module.exports = __webpack_public_path__ + "static/media/trash-restore-alt.d9dd2774.svg";